export default "__VITE_ASSET__CFGu$d6c__"